// db-stats.js


(function(){

  let statsChartInstance;

  const catMapping = {
    surface:  'Surface',
    glide:    'Glide Type',
    firmness: 'Firmness',
    base:     'Base',
    texture:  'Texture'
  };

  function buildStatsChart(specType) {
    const products = window.allProducts || [];
    let labels = [], data = [], isHorizontal = false;

    // 1) Build labels & data
    if (specType === 'length') {
      // numeric length histogram
      const dimsField = getTagFieldsForType(currentProductType).find(f => f.label === 'Dims');
      if (!dimsField) { alert('No “Dims” field.'); return; }
      const prefix = dimsField.prefix;
      const vals = products.flatMap(p => {
        const t = p.tags.find(x => x.startsWith(prefix));
        if (!t) return [];
        const num = parseFloat(
          t.slice(prefix.length).replace(/mm$/i,'').split(/[×x]/)[0]
        );
        return isNaN(num) ? [] : [num];
      });
      if (!vals.length) { alert('No length data.'); return; }

      const bins = 10;
      const min  = Math.min(...vals);
      const max  = Math.max(...vals);
      const size = (max - min) / bins;
      const counts = Array(bins).fill(0);
      vals.forEach(v => {
        const i = Math.min(Math.floor((v - min) / size), bins - 1);
        counts[i]++;
      });
      labels = counts.map((_, i) =>
        `${Math.round(min + i*size)}–${Math.round(min + (i+1)*size)}`
      );
      data = counts;

    } else {
      // categorical specs (horizontal)
      isHorizontal = true;
      const key = catMapping[specType];
      const tagDef = getTagFieldsForType(currentProductType).find(f => f.label === key);
      if (!tagDef) { alert(`No “${key}” field.`); return; }

      // frequency map
      const freq = {};
      products.forEach(p => {
        const t = p.tags.find(x => x.startsWith(tagDef.prefix));
        const v = t ? t.replace(tagDef.prefix, '').trim() : '—';
        freq[v] = (freq[v] || 0) + 1;
      });

      // sort descending and group any <2% into “Other”
      const entries    = Object.entries(freq).sort((a,b) => b[1] - a[1]);
      const totalCount = entries.reduce((sum,[,c]) => sum + c, 0);

      const main = [];
      let otherCount = 0;
      entries.forEach(([label, count]) => {
        const pct = (count / totalCount) * 100;
        if (pct >= 2) {
          main.push([label, count]);
        } else {
          otherCount += count;
        }
      });
      if (otherCount > 0) main.push(['Other', otherCount]);

      labels = main.map(e => e[0]);
      data   = main.map(e => e[1]);
    }

    // 2) Compute percentages
    const total = data.reduce((s, v) => s + v, 0);
    const pct   = data.map(v => total ? ((v/total)*100).toFixed(1) : '0');

    // 3) Generate one HSL color per bar
    const bgColors = labels.map((_, i) => {
      const hue = Math.round((i * 360) / labels.length);
      return `hsl(${hue}, 70%, 50%)`;
    });

    // 4) Render the chart
    const canvas = document.getElementById('statsChart');
    if (!canvas) return console.error('No statsChart canvas.');
    const ctx = canvas.getContext('2d');
    if (statsChartInstance?.destroy) statsChartInstance.destroy();
    if (window.ChartDataLabels) Chart.register(ChartDataLabels);

    statsChartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: specType === 'length'
            ? 'Length (mm)'
            : `${catMapping[specType]}`,
          data,
          backgroundColor: bgColors,
          borderRadius: 6,
          barThickness: specType === 'length' ? undefined : 24
        }]
      },
      options: {
        indexAxis: isHorizontal ? 'y' : 'x',
        maintainAspectRatio: false,
        animation: { duration: 800, easing: 'easeOutQuart' },
        layout: { padding: { top:12, bottom:12, left:12, right:70 } },
        scales: {
          x: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { color: '#000', font: { size: 12 } }
          },
          y: {
            grid: { color: 'rgba(0,0,0,0.05)' },
            ticks: { color: '#000', font: { size: 12 } }
          }
        },
        plugins: {
          title: {
            display: true,
            text: specType === 'length'
              ? 'Length'
              : `${catMapping[specType]}`,
            font: { size: 18, weight: '500' },
            padding: { top: 0, bottom: 10 },
            color: '#000'
          },
          legend: { display: false },
          datalabels: {
            anchor: isHorizontal ? 'end' : 'end',
            align:  isHorizontal ? 'right' : 'top',
            offset: 6,
            color:  '#000',
            font:   { weight: 'bold', size: 12 },
            formatter: (v, ctx) => `${v} (${pct[ctx.dataIndex]}%)`
          },
          tooltip: {
            backgroundColor: '#222',
            titleFont: { size: 14 },
            bodyFont: { size: 12 }
          }
        }
      }
    });
  }

function bindSpecsStats() {
  const btn = document.getElementById('openStatsBtn');
  if (!btn || btn.dataset.statsBound) return;
  btn.dataset.statsBound = 'true';

  btn.addEventListener('click', () => {
    // 1) Create modal only once
    let modal = document.getElementById('statsModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'statsModal';
      modal.innerHTML = `
        <div class="modal-backdrop"></div>
        <div class="modal-content">
          <button id="closeStatsBtn">&times;</button>
          <div class="stats-controls">
            <select id="statsSpecSelect">
              <option value="length">Length (mm)</option>
              <option value="surface">Surface</option>
              <option value="glide">Glide Type</option>
              <option value="texture">Texture</option>
              <option value="firmness">Firmness</option>
              <option value="base">Base</option>
            </select>
          </div>
          <div class="chart-wrapper">
            <canvas id="statsChart"></canvas>
          </div>
        </div>
      `;
      // new: if we're in fullscreen, put it inside that element, otherwise fall back to body
      const parent = document.fullscreenElement || document.body;
      parent.appendChild(modal);

      // bind close button
      modal.querySelector('#closeStatsBtn').onclick = () => {
        modal.style.display = 'none';
      };
      // rebuild bar-chart when spec changes
      modal.querySelector('#statsSpecSelect')
        .addEventListener('change', e => buildStatsChart(e.target.value));
    }

    modal.style.display = 'flex';
    const sel = modal.querySelector('#statsSpecSelect');
    buildStatsChart(sel.value);
  });
}

window.bindSpecsStats = bindSpecsStats;

// Auto-init when DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSpecsStats);
} else {
  bindSpecsStats();
}

})();